import { Button, ConfigProvider, Form, Input } from "antd";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import m3_logo from "../assets/images/M3_Logo.svg";
import { validateConfirmPassword, validatePassword } from "../utils/constant";
import GradientButton from "../Components/Button/GradientButton";
import { LoadingOutlined } from "@ant-design/icons";
import { updateAwsPassword } from "../utils/AWS/awsPassword";
import toastMessage from "../utils/toastMessage";

function ResetPassword() {
  const Navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  console.log(location.state, " = location.state");

  const handleResetPassword = ({ password }) => {
    setLoading(true);
    updateAwsPassword(location.state.username, password, location.state.otp, (err, msg)=>{
      setLoading(false);
      if(err){
        toastMessage(err, "error");
        Navigate("/password-reset-otp")
      }
      else{
        toastMessage(msg, "success");
        Navigate("/signin");
      }
    });
    // console.log(password, " = password, ", location.state.otp, " = otp, ", location.state.username, " = username");
  }

  return (
    <ConfigProvider
      theme={{
        components: {
          Input: {
            colorBgContainer: "transparent",
            colorIcon: "white",
            colorIconHover: "white",
            colorTextPlaceholder: "#DADADA",
            colorText: "white",
          },
          Form: {
            colorTextHeading: "white",
          },
        },
      }}
    >
      <div className="bg-darkJungleGreen h-screen flex justify-center items-center text-white">
        <div className="m3_logo_register absolute top-10 left-16">
          <img src={m3_logo} />
        </div>
        <div className="bg-black shadow-signupBoxShadow px-10 py-28 w-[494px] rounded-2xl space-y-5">
          <h1 className="font-bold bg-signupTextBg inline-block text-transparent bg-clip-text text-2xl">
            New Password
          </h1>
          <p>Enter your new password !</p>
          <Form
            className=" text-white"
            name="basic"
            labelCol={{
              span: 24,
            }}
            wrapperCol={{
              span: 24,
            }}
            // initialValues={{ remember: true }}
            onFinish={handleResetPassword}
            // onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <Form.Item
              label="New Password"
              name="password"
              rules={[
                {
                  required: true,
                  message: "Please input your password!",
                },
                validatePassword,
              ]}
            >
              <Input.Password placeholder="Enter password" />
            </Form.Item>
            <Form.Item
              label="Re-enter New Password"
              name="confirmPassword"
              rules={[
                {
                  required: true,
                  message: "Please input your password again!",
                },
                validateConfirmPassword,
              ]}
            >
              <Input.Password placeholder="Confirm your Password" />
            </Form.Item>
            <Form.Item className="mb-0">
              <GradientButton
                // onClick={() => Navigate("/get-to-know")}
                className="bg-signupSubmitBtn flex items-center w-full rounded-3xl"
                // type="primary"
                type="submit"
                disabled={loading}
              >
                <span>Confirm</span>
                {loading && <span><LoadingOutlined style={{ fontSize: 20, color: 'white', }} /></span>}
              </GradientButton>
            </Form.Item>
          </Form>
        </div>
      </div>
    </ConfigProvider>
  );
}

export default ResetPassword;
